import { action, computed, decorate, observable } from "mobx";
import { CONTENT_EXPERIENCE } from "../utils/constants";

export const EXPERIENCE_STORAGE_KEY = "sporty.experience";

const EXPERIENCE_SEARCH_TYPES = {
  [CONTENT_EXPERIENCE.MLB]: "UNIFIED",
  [CONTENT_EXPERIENCE.MILB]: "MILB_UNIFIED"
};

class ExperienceStore {
  constructor() {
    this.selectedExperience = this._loadPersistedExperience();
    this.allowedExperiences = [];
    this.resolvedExperience = null;
  }

  _loadPersistedExperience() {
    const stored = window.localStorage.getItem(EXPERIENCE_STORAGE_KEY);
    return Object.values(CONTENT_EXPERIENCE).includes(stored) ? stored : null;
  }

  resolve(allowedExperiences) {
    if (!allowedExperiences || allowedExperiences.length === 0) {
      return;
    }
    this.allowedExperiences = allowedExperiences;
    this.resolvedExperience = allowedExperiences.includes(this.selectedExperience)
      ? this.selectedExperience
      : allowedExperiences[0];
  }

  // Intentionally undefined until resolved; defers data loading
  get searchType() {
    return this.resolvedExperience
      ? EXPERIENCE_SEARCH_TYPES[this.resolvedExperience]
      : undefined;
  }

  get isMilbExperience() {
    return this.resolvedExperience === CONTENT_EXPERIENCE.MILB;
  }

  setExperience(experience) {
    if (!Object.values(CONTENT_EXPERIENCE).includes(experience)) {
      return;
    }
    this.selectedExperience = experience;
    this.resolvedExperience = experience;
    window.localStorage.setItem(EXPERIENCE_STORAGE_KEY, experience);
  }
}

decorate(ExperienceStore, {
  selectedExperience: observable,
  allowedExperiences: observable,
  resolvedExperience: observable,
  searchType: computed,
  isMilbExperience: computed,
  resolve: action,
  setExperience: action
});

export default ExperienceStore;



// WEBPACK FOOTER //
// ./src/stores/ExperienceStore.js